import React, {memo, useEffect, useMemo, useState} from "react";
import Styles from './DoughnutChart/DoughnutChart.module.scss'
import Moment from "moment";
import {
    Chart,
    ArcElement,
    LineElement,
    BarElement,
    PointElement,
    BarController,
    BubbleController,
    DoughnutController,
    LineController,
    PieController,
    PolarAreaController,
    RadarController,
    ScatterController,
    CategoryScale,
    LinearScale,
    LogarithmicScale,
    RadialLinearScale,
    TimeScale,
    TimeSeriesScale,
    Decimation,
    Filler,
    Legend,
    Title,
    Tooltip
} from 'chart.js';
import {isNumber} from "chart.js/helpers";
import {showDuration, showFileName} from "../../../../util/util";
import {object} from "prop-types";

Chart.register(
    ArcElement,
    LineElement,
    BarElement,
    PointElement,
    BarController,
    BubbleController,
    DoughnutController,
    LineController,
    PieController,
    PolarAreaController,
    RadarController,
    ScatterController,
    CategoryScale,
    LinearScale,
    LogarithmicScale,
    RadialLinearScale,
    TimeScale,
    TimeSeriesScale,
    Decimation,
    Filler,
    Legend,
    Title,
    Tooltip
);


const DoughnutChart = props => {

    const [tab , setTab] = useState('case_frequency')
    const [labels , setLabels] = useState([])
    const [values , setValues] = useState([])
    const [doughnut , setDoughnut] = useState(false)
    const [currentTabs , setCurrentTabs] = useState([])


    // function ErrorHandling(){
    //     return (
    //         <div> ssdsd sdsdsd sdsdsdsd sdsd</div>
    //     )
    // }

    const drawChart = (labels,data) => {
        const el = document.getElementById('doughnut')
         if(!el) return
         const ctx = el.getContext('2d');
        const image = new Image();
        image.src = 'https://www.chartjs.org/img/chartjs-logo.svg';
        // Note: changes to the plugin code is not reflected to the chart, because the plugin is loaded at chart construction time and editor changes only trigger an chart.update().
        let doughnut = new Chart(ctx, {
            type: 'doughnut',
            data: {
                labels: labels,
                datasets: [{
                    label: '# of Votes',
                    data: data,
                    backgroundColor: ['#8A0FFF','#FF0053','#FFC700','#02DEAB','#70789E','#C2C7ED'],
                    borderWidth: 2,
                    borderRadius:5,
                    borderSkipped: true,
                }]
            },
            options: {
                aspectRatio: 5,
                cutout:55,
                maintainAspectRatio: false,
                // responsive:true,
                scales: {
                    y: {
                        display:false,
                        beginAtZero: true,
                    },
                },
                plugins: {
                    cutout:30,
                    legend: {
                        display: false,
                    },
                }
            },
        });
        // doughnut.canvas.parentNode.style.height = '162px';
         setDoughnut(doughnut)
    }



    useEffect(()=>{
       if(props.data && props.data[tab] && !props.loading){
           let labels = Object.keys(props.data[tab]) || []
           let data =  []
           Object.keys(props.data[tab]).forEach(value => {
               if(value !== 'total' && value !== 'other')
               data.push(props.data[tab][value].percent)
           })
           setLabels(labels)
           if(data.length && labels.length){
               if(doughnut) doughnut.destroy()
               drawChart(labels,data)
           }
       }
    },[props.loading,tab])


    useEffect(()=>{
        let tabs = Object.keys(props.data || {})
        // tabs = props.select.includes('case') ? ['throughput_time','event_counts'] : ['case_frequency']
        // tabs.filter(tab => !tab.includes('average') && !tab.includes('variant') && !tab.includes('counts'))
        // console.log('========================================',tabs)
        let tab = 'case_frequency'
        if(String(props.select || '').toUpperCase() === 'CASEID'){
            setCurrentTabs(tabs)
            // tabs = tabs.map(tab => tab === 'throughput_time')
            // console.log('fatemeh',tabs)
            setTab('throughput_time')
        }else{
            tabs = tabs.filter(tab => !tab.includes('total') && !tab.includes('variant') && !tab.includes('counts') && !tab.includes('tpt'))
            setCurrentTabs(tabs)
            setTab('case_frequency')
        }
    },[props.data])

    // useEffect(()=>{
    //     setTab(currentTabs[0])
    // },[currentTabs])



    useEffect(()=>{
          if(labels.length > 0){
              let values = {}
              labels.forEach((item) => {
                  values[item] = {value : (tab.toLowerCase().includes('time') || tab.toLowerCase().includes('duration')) ? showDuration(props.data[tab][item]?.value) : props.data[tab][item]?.value, percent : props.data[tab][item]?.percent}
              })
              console.log('values',values)
              setValues(values)
          }
    },[labels])


    useEffect(()=>{
       if(!props.loading){
           labels.forEach((item) => {
               values[item] = {value : (tab.toLowerCase().includes('time') || tab.toLowerCase().includes('duration')) ? showDuration(props.data[tab][item]?.value) : props.data[tab][item]?.value, percent : props.data[tab][item]?.percent}
           })
           console.log('values',values)
           console.log('loading',labels,values)
       }
    },[props.loading])


    try {
        return(
            <div className={Styles.doughnutChart}>
                <nav className={`${Styles.nav} d-flex justify-content-between align-items-center`}>
                    <div className="d-flex align-items-center">
                        {currentTabs.map((_tab,key) => (
                            <div key={key}>
                                <p onClick={() => setTab(_tab)} className={`cap fw600 ${tab === _tab && Styles.active}`}>{_tab !== 'case_frequency' && (props.select.toLowerCase().includes('case') ? 'Total ' : 'AVG ')}{_tab.replaceAll('_',' ').replace(/total|average|avg/gi,'')}</p>
                            </div>
                        ))}
                    </div>
                    <svg style={{marginRight:18}} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.1018 18.8634L16.1018 8.82925" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.5319 16.4237L16.1019 18.8637L13.6719 16.4237" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M19.9624 12.7733H20.7399C22.4358 12.7733 23.8099 14.1475 23.8099 15.8442V19.9142C23.8099 21.6058 22.4391 22.9767 20.7474 22.9767H11.4641C9.76827 22.9767 8.39327 21.6017 8.39327 19.9058L8.39327 15.835C8.39327 14.1442 9.76494 12.7733 11.4558 12.7733H12.2408" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                </nav>
                <div className="d-flex">
                    <div className={`d-flex justify-content-center align-items-center ${Styles.doughnutContainer}`}>
                        {/*<canvas id="myChart" width="162" height="162"></canvas>*/}
                        <canvas id="doughnut" width="162" height="162"></canvas>
                        <p className={Styles.chartTitle}>Top 5 <br/><span style={{textTransform:'capitalize'}}>{props.select.toLowerCase().replace('id','')}</span></p>
                    </div>
                    <div className={Styles.chartDetail}>
                        <header className="d-flex justify-content-between">
                            <div className="d-flex align-items-center">
                                <div className={Styles.dot+' '+Styles.dotBorder}></div>
                                <p className="f12 fw600 dark-gary-2 cap">{props.select.toLowerCase().replace('id','')}</p>
                            </div>
                            <p className="f12 fw600 dark-gary-2 cap">{tab !== 'case_frequency' && (props.select.toLowerCase().includes('case') ? 'Total ' : 'AVG ')}{tab.replaceAll('_',' ').replace(/total|average|avg/gi,'')}</p>
                        </header>
                        <main>
                            {/*<div className="mb-2 d-flex justify-content-between">*/}
                            {/*    {labels.map((item,key)=> {*/}
                            {/*        return <div className="d-flex align-items-center">*/}
                            {/*                  <div className={Styles.dot}></div>*/}
                            {/*                  <p style={{height:14}}  className="f12 fw300 dark-gary-2" title={item}>{showFileName(item,25)}</p>*/}
                            {/*               </div>*/}
                            {/*    })}*/}
                            {/*    {values.map((item,key)=> {*/}
                            {/*        return   <p className="f12 fw500 dark-gary-2">*/}
                            {/*            {console.log('test',props.data[tab][item],item)}*/}
                            {/*            /!*{showValue('value',item)} | {showValue('percent',item)}%*!/*/}
                            {/*            /!*{data[tab][item].percent}*!/*/}
                            {/*        </p>*/}
                            {/*    })}*/}
                            {/*</div>*/}
                            {labels.map((item,key)=> {
                                if (item !== 'total'){
                                    return  <div key={key} className="mb-2 d-flex justify-content-between">
                                        <div style={{width:'50%'}} className="d-flex align-items-center">
                                            <div className={Styles.dot}></div>
                                            <p style={{height:14}}  className="f12 fw300 dark-gary-2 text-overflow" title={item}>{item}</p>
                                        </div>
                                        <p className="f12 fw500 dark-gary-2">
                                            {values[item]?.value} | {values[item]?.percent}%
                                            {/*{data[tab][item].percent}*/}
                                        </p>
                                    </div>
                                }

                            })}
                        </main>
                        <footer className="d-flex justify-content-between">
                            <div className="d-flex align-items-center">
                                <div className={Styles.dot+' '+Styles.dotBorder}></div>
                                <p className="f12 fw600 dark-gary-2">Total</p>
                            </div>
                            <p className="f12 fw500 dark-gary-2">
                                {values?.total?.value} | {values?.total?.percent}%
                                {/*{showValue('value')} | {showValue('percent')}*/}
                            </p>
                        </footer>
                    </div>
                </div>
            </div>
            // <ErrorHandling/>
        )
    }catch (er){
        return <ErrorHandling/>
    }
}
export default memo(DoughnutChart);


const ErrorHandling = () =>  {
    return (
        <div> er</div>
    )
}
